"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("../../../../../core/button"));
var _submit = _interopRequireDefault(require("../../../../../core/submit"));
var _modal = _interopRequireDefault(require("../../../../../core/modal"));
var _input = _interopRequireDefault(require("../../../../../core/input"));
var _editableField = _interopRequireDefault(require("../../../../../core/editable-field"));
var _alert = _interopRequireDefault(require("../../../../../core/alert"));
var _occasion = _interopRequireDefault(require("occasion"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("p", null, "Entry could not be found");
var _ref2 = /*#__PURE__*/_react.default.createElement("p", null, "You can switch a paddler to another session with their agreement. However, you cannot select a session in which the paddler already has an entry (including draft and cancelled entries).");
var _ref3 = /*#__PURE__*/_react.default.createElement(_alert.default, null, "Click confirm to move this entry to the selected session.", ' ', /*#__PURE__*/_react.default.createElement("strong", null, "Please ensure that you agree the change with the paddler; they will NOT be notified by the system"));
class SwitchSessionModal extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      updating: false,
      selectedRaceID: null
    });
    _defineProperty(this, "_getSwitchOptions", competitionDay => {
      const currentRace = this.props.entry.race;
      const availableRaces = competitionDay.races.filter(r => r.defaultRaceID === currentRace.defaultRaceID);
      const options = availableRaces.map(race => {
        const raceEntries = competitionDay.entries.filter(e => e.raceID === race.id).map(e => e.cseBibID);
        const existingEntry = raceEntries.includes(this.props.entry.cseBibID);
        return {
          disabled: race.id !== currentRace.id && existingEntry,
          ...race
        };
      });
      return options;
    });
    _defineProperty(this, "_getSelectedRaceID", () => {
      return this.state.selectedRaceID || this.props.entry.race.id;
    });
    _defineProperty(this, "_onSetSelectedRaceID", value => {
      this.setState({
        selectedRaceID: +value
      });
    });
    _defineProperty(this, "_onConfirm", async () => {
      this.setState({
        updating: true
      });
      await this.props.onConfirm(this.props.entryID, this._getSelectedRaceID());
      this.props.onCloseCancel();
    });
  }
  render() {
    const entry = this.props.entry;
    const competitionDays = entry.race.competitionDivision.competitionDays;
    if (!entry) {
      return /*#__PURE__*/_react.default.createElement(_modal.default, {
        title: " ",
        size: "lg",
        onClose: this.props.onCloseCancel
      }, _ref);
    }
    return /*#__PURE__*/_react.default.createElement(_modal.default, {
      title: "Switch Session",
      buttons: /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_button.default, {
        onClick: this.props.onCloseCancel
      }, "Cancel"), /*#__PURE__*/_react.default.createElement(_submit.default, {
        type: "primary",
        onClick: () => this._onConfirm(this.props.entryID, this._getSelectedRaceID()),
        disabled: this.props.entry.race.id === this._getSelectedRaceID() || this.state.updating,
        loading: this.state.updating
      }, "Confirm")),
      size: "lg",
      onClose: this.props.onCloseCancel
    }, _ref2, competitionDays.map(cday => /*#__PURE__*/_react.default.createElement("div", {
      key: cday.id
    }, !this._getSwitchOptions(cday).length ? null : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h5", {
      key: cday.id
    }, (0, _occasion.default)(cday.dayDate, 'dddd'), ":"), this._getSwitchOptions(cday).map(option => /*#__PURE__*/_react.default.createElement(_input.default, {
      key: option.id,
      type: "Radio",
      name: "session",
      disabled: option.disabled,
      checked: this._getSelectedRaceID() === option.id,
      onChange: this._onSetSelectedRaceID,
      value: option.id,
      label: /*#__PURE__*/_react.default.createElement("span", {
        className: option.disabled ? 'read-only' : ''
      }, /*#__PURE__*/_react.default.createElement("strong", null, option.raceName), " - Completed Entries: ", option.numberOfCompletedEntries, "; Waiting List: ", option.numberOnWaitingList)
    }))))), this._getSelectedRaceID() === entry.race.id ? null : _ref3);
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref4 = {
  id: true,
  cseBibID: true,
  race: {
    id: true,
    defaultRaceID: true,
    competitionDivision: {
      competitionDays: {
        id: true,
        dayDate: true,
        entries: {
          cseBibID: true,
          raceID: true
        },
        races: {
          id: true,
          defaultRaceID: true,
          raceName: true,
          numberOfCompletedEntries: true,
          numberOnWaitingList: true
        }
      }
    }
  }
};
var _default = exports.default = (0, _reactBicycle.connect)(SwitchSessionModal, props => ({
  ["entry(entryID:" + JSON.stringify(props.entryID) + ")"]: _ref4
}), (client, props) => ({
  onConfirm(entryID, newRaceID) {
    return client.update('Entry.switchSession', {
      entryID,
      newRaceID
    });
  }
}));